import type { SVGProps } from 'react';

/** Figma `tab-home.svg` — `tools/make-icon-components.py`가 만든다. 손으로 고치지 않는다. */
export const TabHomeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Frame">
      <path
        id="Vector"
        d="M4 11L12 4L20 11V20C20 20.2652 19.8946 20.5196 19.7071 20.7071C19.5196 20.8946 19.2652 21 19 21H15V15H9V21H5C4.73478 21 4.48043 20.8946 4.29289 20.7071C4.10536 20.5196 4 20.2652 4 20V11Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
